import StatusProject from "pages/projects/molecules/StatusProject"
import Typography from "components/Typography"
import { ProjectDetail, ProjectStatus } from "pages/projects/types"
import { TippyCustomzie } from "components/TippyCustomzie"
import { useBoolean, useString, useWindowSize } from "helpers/hooks"
import ActionItem from "pages/projects/molecules/ActionItem"
import { LIST_STATUS_PROJECT } from "pages/projects/project.constant"
import RoleUsersCard from "pages/projects/molecules/RoleUsersCard"
import { Avatar } from "components/Avatar"
import { useContext, useEffect } from "react"
import { PermissionProjectPage } from "../contexts/PermissionProjectPage.context"
import {
  checkPermissionPage,
  getFirstLetterInName,
  showImageUrl,
} from "helpers/utils"
import Tippy from "@tippyjs/react"
import { useAppSelector } from "hooks/useApp"
import Button from "components/Button/Button"
import { ReactComponent as IconSetting } from "assets/images/icons/icon-settings.svg"
import DotCard from "pages/conversations/atoms/DotCard"
import { PERMISSIONS } from "constants/permissions"
import ActionIconHistory from "pages/project-component-detail/molecules/ActionIconHistory"
import { pushTo } from "helpers/history"
import { PATH } from "constants/path"
import { ReactComponent as IconMenuGroup } from "assets/images/icons/group-project.svg"
import { API_URL } from "config/environments"

interface Props {
  projectDetail: ProjectDetail
  handleChangeStatusProject: (
    idStatus: string,
    callback: () => void
  ) => () => void
  onClickAction: (
    key: "edit" | "archive" | "delete",
    callback: () => void
  ) => () => void
  handleShare: () => void
  handleChangeData?: (newProject?: ProjectDetail) => void
  isDeleted?: boolean
}
const InfoProjectCard = (props: Props) => {
  const {
    projectDetail,
    handleShare,
    handleChangeStatusProject,
    onClickAction,
    isDeleted,
  } = props
  const { isMobile } = useWindowSize()
  const showTippy = useBoolean(false)
  const showTippyName = useBoolean(false)
  const editDescription = useString("")
  const { archiveProject, viewOnlyShare } = useContext(PermissionProjectPage)
  const userInfo = useAppSelector((state) => state.userInfo)

  useEffect(() => {
    editDescription.setValue(projectDetail.description)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectDetail.description])
  const handleClickTippy = (event) => {
    event.stopPropagation()
    event.preventDefault()
    if (
      checkPermissionPage(PERMISSIONS.PROJECT_EDIT, {
        project: archiveProject,
        viewShare: viewOnlyShare,
      }) ||
      isDeleted
    ) {
      return
    }
    showTippy.setValue(!showTippy.value)
  }
  const handleClickTippyName = (event) => {
    event.stopPropagation()
    event.preventDefault()
    if (
      checkPermissionPage(PERMISSIONS.PROJECT_EDIT, {
        viewShare: viewOnlyShare,
      }) ||
      isDeleted
    ) {
      return
    }
    showTippyName.setValue(!showTippyName.value)
  }
  const urlAvatar = (newUrl: string) => {
    if (!newUrl.includes("public/")) {
      return undefined
    }
    return API_URL
  }
  const renderRoleUser = () => {
    if (!projectDetail.role_users || !projectDetail) {
      return null
    }
    if (userInfo.last_organization_id) {
      const projectOwner = projectDetail.role_users.find((i) => i.role === 1)

      return (
        <div className="flex items-center gap-[12px] mr-[12px]">
          {projectDetail.group_organizations?.length ? (
            <div className="flex items-center">
              <span
                className="font-medium"
                style={{
                  color: "#7A7A7A",
                  fontSize: 12,
                  lineHeight: "18px",
                  marginRight: 4,
                }}
              >
                Assigned to:
              </span>
              {projectDetail.group_organizations.map((elGroup, index) => {
                return (
                  <Tippy
                    key={index}
                    className="custom-tippy-menu-left"
                    placement="bottom"
                    content={
                      <p>
                        {elGroup.group_organization_id
                          ? `${elGroup.code} - ${elGroup.name}`
                          : `${elGroup.name} - ${elGroup.email}`}
                      </p>
                    }
                  >
                    <div
                      key={index}
                      className="flex items-center justify-center active-menu-left"
                      style={{
                        width: 24,
                        height: 24,
                        border: "1px solid #FFFFFF",
                        backgroundColor: elGroup.avatar
                          ? "transparent"
                          : elGroup.group_organization_id
                          ? "#FDBE4426"
                          : "#F7AC1B",
                        borderRadius: "50%",
                        marginLeft: index > 0 ? -8 : 0,
                      }}
                    >
                      {elGroup.group_organization_id ? (
                        <IconMenuGroup width={12} height={12} />
                      ) : (
                        <>
                          {elGroup.avatar ? (
                            <img
                              src={showImageUrl(
                                elGroup.avatar,
                                urlAvatar(elGroup.avatar)
                              )}
                              alt="avatar"
                              style={{
                                borderRadius: "50%",
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            <p
                              style={{
                                fontWeight: 500,
                                fontSize: 11,
                                lineHeight: "18px",
                                color: "#FFF",
                              }}
                            >
                              {getFirstLetterInName(
                                elGroup.name || "N/A",
                                true
                              )}
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </Tippy>
                )
              })}
            </div>
          ) : null}

          <div className="flex items-center">
            <span
              className="font-medium"
              style={{
                color: "#7A7A7A",
                fontSize: 12,
                lineHeight: "18px",
                marginRight: 4,
              }}
            >
              Owner:
            </span>
            <Tippy
              className="custom-tippy-menu-left"
              placement="bottom"
              content={
                <div className="text-center">
                  <p>{projectOwner?.fullname}</p>
                  <p>{projectOwner?.email}</p>
                </div>
              }
            >
              <div className="cursor-pointer">
                <Avatar
                  width="24px"
                  height="24px"
                  name={projectOwner?.fullname}
                  avatar={projectOwner?.avatar}
                  textcolor="white"
                  contentsize="11px"
                  justOneLetter={true}
                />
              </div>
            </Tippy>
          </div>
        </div>
      )
    }

    const owner = projectDetail.role_users.find(
      (i) => i.user_id === projectDetail.created_by
    )
    const contributors =
      projectDetail.role_users.filter(
        (i) => i.user_id !== projectDetail.created_by
      ) || []

    if (userInfo.id === owner?.user_id && !contributors.length) {
      return null
    }

    return (
      <div className="flex items-center mr-1">
        {owner && userInfo.id !== owner.user_id ? (
          <div className="flex items-center mr-[12px]">
            <span
              className="font-medium"
              style={{
                color: "#7A7A7A",
                fontSize: 12,
                lineHeight: "18px",
                marginRight: 4,
              }}
            >
              Owner:
            </span>
            <Tippy
              className="custom-tippy-menu-left"
              placement="bottom"
              content={
                <div className="text-center">
                  <p>{owner.fullname}</p>
                  <p>{owner.email}</p>
                </div>
              }
            >
              <div className="cursor-pointer">
                <Avatar
                  width="24px"
                  height="24px"
                  name={owner.fullname}
                  avatar={owner.avatar}
                  textcolor="white"
                  contentsize="11px"
                  justOneLetter={true}
                />
              </div>
            </Tippy>
          </div>
        ) : null}
        {contributors.length > 0 ? (
          <>
            <div>
              <span
                className="font-medium"
                style={{
                  color: "#7A7A7A",
                  fontSize: 12,
                  lineHeight: "18px",
                  marginRight: 4,
                }}
              >
                Contributors:
              </span>
            </div>
            <RoleUsersCard
              data={contributors}
              max={projectDetail.role_users.length}
            />
          </>
        ) : null}
      </div>
    )
  }

  const renderDesciption = () => (
    <p className="font-sm cursor-pointer color-[#111111] leading-6 custom-break-words  mt-0 md:mt-[31px]">
      {projectDetail.description}
    </p>
  )

  return (
    <div className="flex flex-col md:flex-row justify-between px-6 py-2 gap-y-3 md:gap-y-0 bg-white border-b border-[#E4E4E4]">
      <div className="flex flex-grow flex-col md:justify-between  ">
        <div className="flex flex-col md:flex-row-reverse items-start md:items-center md:justify-end gap-2 md:gap-0 ">
          <div className="flex items-center">
            <Typography
              variant="h6"
              style={{
                color: "#111111",
                lineHeight: "26px",
                fontWeight: 600,
              }}
            >
              {projectDetail.name}
            </Typography>
          </div>

          {!isDeleted && userInfo.id === projectDetail.created_by ? (
            <TippyCustomzie
              containerClass="component-card-menu"
              placement="bottom-end"
              interactive
              arrow={false}
              animation="scale"
              visible={showTippy.value}
              offset={[20, 7]}
              onClickOutside={() => showTippy.setValue(false)}
              content={
                <div
                  style={{
                    background: "#222222",
                    borderRadius: 4,
                    paddingTop: 8,
                    paddingBottom: 8,
                    width: 100,
                  }}
                >
                  {LIST_STATUS_PROJECT.filter((el) => el.id).map(
                    (status, index) => (
                      <ActionItem
                        key={index}
                        title={status.label}
                        onClick={handleChangeStatusProject(status.id, () =>
                          showTippy.setValue(false)
                        )}
                      />
                    )
                  )}
                </div>
              }
              allowHTML
            >
              <div className="flex items-center">
                <p
                  className=" md:hidden font-semibold"
                  style={{
                    fontSize: 13,
                    lineHeight: "22px",
                    color: "#333333",
                  }}
                >
                  {projectDetail.code}
                </p>
                {isMobile && <DotCard />}

                <div onClick={handleClickTippy} className="cursor-pointer">
                  <StatusProject
                    status={
                      projectDetail.is_archived
                        ? ProjectStatus.Archive
                        : projectDetail.status || 4
                    }
                    isIcon={
                      !checkPermissionPage(PERMISSIONS.PROJECT_EDIT, {
                        project: archiveProject,
                        viewShare: viewOnlyShare,
                      })
                    }
                    minWidth={85}
                  />
                </div>
              </div>
            </TippyCustomzie>
          ) : null}
        </div>

        {isMobile ? null : renderDesciption()}
      </div>

      <div className="flex justify-between flex-col ml-0 md:ml-2 gap-y-3 md:gap-y-0">
        <div className="flex justify-start md:justify-end">
          {projectDetail.categories && projectDetail.categories.length
            ? projectDetail.categories.map((category, index) => (
                <div
                  key={index}
                  className="flex items-center md:px-2 h-26-custom mr-1 last:mr-0"
                  style={{
                    background: "#F7F7F7",
                    borderRadius: 4,
                  }}
                >
                  <p
                    className="font-medium"
                    style={{
                      color: "#7A7A7A",
                      fontSize: 12,
                      lineHeight: "18px",
                    }}
                  >
                    {category.name}
                  </p>
                </div>
              ))
            : null}
        </div>

        <div className="flex justify-between md:justify-end">
          {renderRoleUser()}
          {!isDeleted ? (
            <div className="flex justify-between gap-3 md:gap-0 ">
              {!userInfo.last_organization_id ? (
                <Button
                  title="Share"
                  colorBtn="white"
                  onClick={handleShare}
                  disabled={checkPermissionPage(PERMISSIONS.PROJECT_EDIT, {
                    project: archiveProject,
                    viewShare: userInfo.id !== projectDetail.created_by,
                  })}
                  sizeBtn="small"
                />
              ) : null}

              {!checkPermissionPage(PERMISSIONS.PROJECT_EDIT, {
                viewShare: viewOnlyShare,
              }) && (
                <TippyCustomzie
                  containerClass="component-card-menu"
                  placement="bottom-end"
                  disabled={checkPermissionPage(PERMISSIONS.PROJECT_EDIT, {
                    project: archiveProject,
                    viewShare: viewOnlyShare,
                  })}
                  interactive
                  arrow={false}
                  animation="scale"
                  visible={showTippyName.value}
                  offset={[0, 7]}
                  allowHTML
                  onClickOutside={() => showTippyName.setValue(false)}
                  content={
                    <div
                      onClick={() =>
                        showTippyName.setValue(!showTippyName.value)
                      }
                      style={{
                        background: "#222222",
                        borderRadius: 4,
                        paddingTop: 8,
                        paddingBottom: 8,
                        width: 170,
                      }}
                    >
                      {projectDetail.is_archived === 0 ? (
                        <ActionItem
                          className="hidden md:flex"
                          title="Edit"
                          onClick={onClickAction("edit", () =>
                            showTippyName.setValue(false)
                          )}
                        />
                      ) : null}
                      <ActionItem
                        title={
                          projectDetail.is_archived === 0
                            ? "Archive"
                            : "Unarchive"
                        }
                        onClick={onClickAction("archive", () =>
                          showTippyName.setValue(false)
                        )}
                      />
                      <ActionItem
                        title={"Delete"}
                        onClick={onClickAction("delete", () =>
                          showTippyName.setValue(false)
                        )}
                      />
                      <ActionItem
                        title={"Assign groups & users"}
                        onClick={() =>
                          pushTo(PATH.assignToGroupPage, {
                            projectId: projectDetail.id,
                          })
                        }
                      />
                      <ActionItem
                        title={"Sync to workspace"}
                        onClick={() =>
                          pushTo(PATH.syncToOrganization, {
                            projectId: projectDetail.id,
                          })
                        }
                      />
                    </div>
                  }
                >
                  <ActionIconHistory
                    icon="setting"
                    disabled={
                      archiveProject ||
                      checkPermissionPage(PERMISSIONS.PROJECT_EDIT, {
                        project: archiveProject,
                        viewShare: viewOnlyShare,
                      })
                    }
                    styleIcon={{ marginRight: 0 }}
                    tooltip="Setting"
                    onClick={handleClickTippyName}
                    classIcon="w-[20px] h-[20px] mt-1"
                  />
                </TippyCustomzie>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
export default InfoProjectCard
